import * as t from "io-ts";

export const IntegrationHistoryCodec = t.intersection([
  t.type({
    type: t.string,
    status: t.string,
    statusDttm: t.number,
  }),
  t.partial({
    description: t.string,
  }),
]);

export const IntegrationHistoryArrayCodec = t.array(IntegrationHistoryCodec);

export type IntegrationHistory = t.TypeOf<typeof IntegrationHistoryCodec>;

export const ObjectIntegrationStatusMapCodec = t.record(
  t.string,
  IntegrationHistoryCodec
);

export type ObjectIntegrationStatusMap = t.TypeOf<typeof ObjectIntegrationStatusMapCodec>;

export const ObjectIntegrationStatusCodec = t.intersection([
  t.type({
    statusMap: ObjectIntegrationStatusMapCodec,
  }),
  t.partial({}),
]);

export type ObjectIntegrationStatus = t.TypeOf<typeof ObjectIntegrationStatusCodec>;
